import {LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {query} from "lit/decorators/query.js";
// @ts-expect-error Could not find a declaration file for module
import ClassicEditor from '@brosua/ckeditor5-simple-custom-build'
import {SbkDatepicker} from "@/components/datepicker/datepicker.ts";
import {SbkCheckbox} from "@/components/checkbox/checkbox.ts";
import "@/components/rte/rte.scss";

@customElement('sbk-oip-cover-letter')
export class SbkOipCoverLetter extends LitElement {

    @query('#emailBodyStart')
    _emailBodyStart!: HTMLElement

    @query('#emailBodyEnd')
    _emailBodyEnd!: HTMLElement

    @query('#customerTalkTakenPlace')
    _customerTalkTakenPlace!: SbkCheckbox

    @query('#callbackDate')
    _callbackDate!: SbkDatepicker

    @query('#customerTalkText')
    _customerTalkText!: HTMLParagraphElement

    @query('#highlightTopModules')
    _advantagesCb!: SbkCheckbox

    @query('#customerTalkAndWithoutModulesText')
    _customerTalkAndWithoutModulesText!: HTMLParagraphElement

    @query('#noCustomerTalkAndWithModulesText')
    _noCustomerTalkAndWithModulesText!: HTMLParagraphElement

    @query('#advantagesIntroductionWithCustomerTalkTakenPlace')
    _advantagesIntroductionWithCustomerTalkTakenPlace!: HTMLParagraphElement

    @query('#advantagesIntroductionWithoutCustomerTalkTakenPlace')
    _advantagesIntroductionWithoutCustomerTalkTakenPlace!: HTMLParagraphElement

    @query('#advantagesWithoutModulesText')
    _advantagesWithoutModulesText!: HTMLParagraphElement

    @query('#advantagesWithModulesText')
    _advantagesWithModulesText!: HTMLParagraphElement

    _dividers = {
        customerTalk: '###DYNAMISCH_INTERESSENTENGESPRAECH###',
        advantages: '###DYNAMISCH_VORTEILE###',
        introductionAdvantages: '###DYNAMISCH_EINFUEHRUNG_VORTEILE###'
    }

    createRenderRoot() {
        return this;
    }

    connectedCallback() {
        super.connectedCallback();
        ClassicEditor.create(this._emailBodyStart)
            // @ts-expect-error implicitly has an 'any' type
            .then(editor => {
                this._initializeCustomerTalkText(editor);
                this._initializeTopModulesText(editor);
            });
        ClassicEditor.create(this._emailBodyEnd);
    }

    // @ts-expect-error implicitly has an 'any' type
    _initializeCustomerTalkText(emailBodyStart) {
        const removeFromTextarea = (divider: string) => {
            const regex = new RegExp('<p>' + divider + '[\\s\\S]*' + divider + '</p>')
            emailBodyStart.setData(emailBodyStart.getData().replace(regex, ''))
        }

        const toggleVisibilityCustomerTalkText = () => {
            this._customerTalkTakenPlace.checked
                ? this._addToTextareaWithDividers(this._customerTalkText.innerText, emailBodyStart, this._dividers.customerTalk, true)
                : removeFromTextarea(this._dividers.customerTalk)
        }

        toggleVisibilityCustomerTalkText()
        this._customerTalkTakenPlace.addEventListener('checkbox-change', () => {
            toggleVisibilityCustomerTalkText();
        })

        const replaceDate = () => {
            const regex = /%1\$s|.{2}\..{2}\..{4}/
            if (this._callbackDate.datepickerValue) {
                emailBodyStart.setData(emailBodyStart.getData().replace(regex, this._callbackDate.datepickerValue))
            } else {
                emailBodyStart.setData(emailBodyStart.getData().replace(regex, 'XX.XX.XXXX'))
            }
        }
        replaceDate()
        this._callbackDate.addEventListener('datepicker-change', () => {
            replaceDate()
        })
    }

    // @ts-expect-error implicitly has an 'any' type
    _initializeTopModulesText(emailBodyStart) {

        const showCorrectAdvantagesText = () => {
            if (this._customerTalkTakenPlace.checked) {
                this._addToTextareaWithDividers(
                    this._advantagesIntroductionWithCustomerTalkTakenPlace.innerText,
                    emailBodyStart,
                    this._dividers.introductionAdvantages,
                    false
                )
            } else {
                this._addToTextareaWithDividers(
                    this._advantagesIntroductionWithoutCustomerTalkTakenPlace.innerText,
                    emailBodyStart,
                    this._dividers.introductionAdvantages,
                    false
                )
            }
            if (this._advantagesCb.checked && this._customerTalkTakenPlace.checked) {
                this._addToTextareaWithDividers(
                    this._advantagesWithModulesText.innerText,
                    emailBodyStart,
                    this._dividers.advantages,
                    false
                )
            } else if (this._advantagesCb.checked && !this._customerTalkTakenPlace.checked) {
                this._addToTextareaWithDividers(
                    this._noCustomerTalkAndWithModulesText.innerText,
                    emailBodyStart,
                    this._dividers.advantages,
                    false
                )
            } else if (!this._advantagesCb.checked && this._customerTalkTakenPlace.checked) {
                this._addToTextareaWithDividers(
                    this._customerTalkAndWithoutModulesText.innerText,
                    emailBodyStart,
                    this._dividers.advantages,
                    false
                )
            } else if (!this._advantagesCb.checked && !this._customerTalkTakenPlace.checked) {
                this._addToTextareaWithDividers(
                    this._advantagesWithoutModulesText.innerText,
                    emailBodyStart,
                    this._dividers.advantages,
                    false
                )
            }
        }

        showCorrectAdvantagesText()
        this._advantagesCb.addEventListener('checkbox-change', () => {
            showCorrectAdvantagesText()
        })
        this._customerTalkTakenPlace.addEventListener('checkbox-change', () => {
            showCorrectAdvantagesText()
        })
    }

    _addToTextareaWithDividers(
        text: string,
        // @ts-expect-error implicitly has an 'any' type
        emailBodyStart,
        divider: string,
        shouldBeInsertedAtBeginning: boolean
    ) {
        const regex = new RegExp(divider + '[[\\s\\S]*' + divider)
        text = divider + '</br>' + text + '</br>' + divider
        if (regex.test(emailBodyStart.getData())) {
            emailBodyStart.setData(emailBodyStart.getData().replace(regex, text))
        } else if (shouldBeInsertedAtBeginning) {
            emailBodyStart.setData(text + emailBodyStart.getData())
        } else {
            emailBodyStart.setData(emailBodyStart.getData() + text)
        }
    }
}
